import { CircleCheck, Info, TriangleAlert } from 'lucide-react';
import { WikiMarkdown } from './WikiMarkdown';
import { isWikiImageUrl, type WikiContentBlock } from '@/lib/wiki-content';
import { cn } from '@/lib/utils';
import { WikiModel } from './WikiModel';

export function WikiArticleBody({ blocks, adminPreview = false }: { blocks: WikiContentBlock[]; adminPreview?: boolean }) {
  return <div className="space-y-8">
    {blocks.map((block, index) => {
      const prefix = `wiki-${index}`;
      if (block.type === 'model') return <WikiModel key={block.id} assetId={block.assetId} caption={block.caption} adminPreview={adminPreview} />;
      if (block.type === 'text') return <WikiMarkdown key={block.id} content={block.text} headingPrefix={prefix} />;
      if (block.type === 'image') return isWikiImageUrl(block.url) ? <figure key={block.id}>
        <img src={block.url} alt={block.caption} loading="lazy" className="mx-auto h-auto max-h-[640px] max-w-full rounded-xl border border-white/10" />
        {block.caption && <figcaption className="mt-3 text-center text-sm text-eol-desc">{block.caption}</figcaption>}
      </figure> : null;
      if (block.type === 'callout') {
        const Icon = block.tone === 'warning' ? TriangleAlert : block.tone === 'success' ? CircleCheck : Info;
        return <aside key={block.id} className={cn('flex gap-3 rounded-xl border p-4 md:p-5',
          block.tone === 'warning' ? 'border-amber-300/20 bg-amber-300/5' : block.tone === 'success' ? 'border-emerald-300/20 bg-emerald-300/5' : 'border-eol-pink/20 bg-eol-pink/5')}>
          <Icon className={cn('mt-1 h-5 w-5 shrink-0', block.tone === 'warning' ? 'text-amber-300' : block.tone === 'success' ? 'text-emerald-300' : 'text-eol-pink')} />
          <div className="min-w-0"><WikiMarkdown content={block.text} headingPrefix={prefix} /></div>
        </aside>;
      }
      return <ol key={block.id} className="wiki-steps">
        {block.items.map((item, step) => <li key={step} className="relative flex gap-4 pb-8 last:pb-0 md:gap-5">
          <span className="wiki-step-number relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-eol-pink/25 bg-[#282027] text-sm font-bold text-eol-pink">{step + 1}</span>
          <div className="min-w-0 flex-1 pt-1">
            <h2 id={`${prefix}-step-${step}`} className="mb-3 text-xl font-bold text-eol-white">{item.title || `Шаг ${step + 1}`}</h2>
            <WikiMarkdown content={item.text} headingPrefix={`${prefix}-step-${step}`} />
          </div>
        </li>)}
      </ol>;
    })}
  </div>;
}
